<template>
    <div>
        <button
            class="btn btn-outline-dark"
            @click="getClasses();openClasses = !openClasses"
        >Show Classes</button>
        <br />
        <div v-if="openClasses">
            <br />
            <b-list-group>
                <b-list-group-item
                    v-for="classroom in classes"
                    v-bind:key="classroom"
                    :to="/classroom/+classroom"
                >{{ classroom }}</b-list-group-item>
            </b-list-group>
            <br />
            <a @click="getOldClasses()" style="variant:blue;cursor:pointer;">Show Inactive Classes</a>
            <b-list-group class="mt-3">
                <b-list-group-item
                    v-for="classroom in oldClasses"
                    v-bind:key="classroom"
                    :to="/classroom/+classroom"
                    variant="warning"
                >{{ classroom }}</b-list-group-item>
            </b-list-group>
        </div>
    </div>
</template>

<script>
const fb = require("../../firebaseConfig");
export default {
    data() {
        return {
            classes: [],
            openClasses: false,
            oldClasses: []
        };
    },
    methods: {
        getClasses() {
            if (this.classes.length) {
                return;
            }
            const queryClass = fb.db
                .collection("classes")
                .where("active", "==", true);
            queryClass
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        this.classes.push(doc.data().name);
                    });
                })
        },
        getOldClasses() {
            if (this.oldClasses.length) {
                return;
            }
            const queryClass = fb.db
                .collection("classes")
                .where("active", "==", false);
            queryClass
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        this.oldClasses.push(doc.data().name);
                    });
                })
        },
    }
};
</script>